import React, { Component } from 'react';
import styled from 'styled-components';
import imageTrellis from '../assets/images/trellisLogo.png';
import media from '../styles/media';

class Hero extends Component {
  render() {
    return (
      <Root>
        <VideoContainer>
          <video autoPlay muted loop>
            <source
              src="https://player.vimeo.com/external/285180367.hd.mp4?s=90d5c4ed1e7d540b9a4fab257ecb3012ff64ff5c&profile_id=175"
              type="video/mp4"
            />
          </video>
        </VideoContainer>
        <Container>
          <TrellisLogo src={imageTrellis} />
          <h1>A future built on the past</h1>
        </Container>
      </Root>
    );
  }
}

export default Hero;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Root = styled.div`
  text-align: right;
  height: 530px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-image: url('/assets/images/header-mobile.jpg');
  background-position: bottom;
  @media (min-width: ${media.sm}) {
    background-image: none;
    margin-top: 0px;
    height: 92vh;
  }
  @media (min-width: ${media.md}) {
    height: 92vh;
  }

  video {
    display: none;
    @media (min-width: ${media.sm}) {
      display: block;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
  align-items: flex-end;
  position: absolute;
  right: 25px;
  top: 20%;

  h1 {
    width: 300px;
    z-index: 998;
  }
  @media (min-width: ${media.sm}) {
    right: 60px;
    top: 30%;
  }
`;

const TrellisLogo = styled.img`
  height: 91px;
  width: 97px;
  margin-bottom: 20px;
  z-index: 998;
`;



// WEBPACK FOOTER //
// ./src/components/Hero.js